import { EventEmitter } from 'expo-core';
export default new EventEmitter({ addListener() {}, removeListeners() {} });
